import { modelState } from '@/utils/modelState';
import { QueryBuilder } from './QueryBuilder';
import { v4 as uuidv4 } from 'uuid';

export namespace LocalExpatGuestCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "LocalExpatGuest",
        name: "Local/Expat Guest",
        isCondition: isLocalExpatGuestCondition,
        create: createLocalExpatGuestCondition,
        hydrate: () => { },
        serialize: serializeLocalExpatGuestCondition,
        deserialize: deserializeLocalExpatGuestCondition,
        renderComponent: () => null
    };

    export const LocalExpatGuestCondition = Symbol("LocalExpatGuestCondition");
    export interface LocalExpatGuestCondition extends QueryBuilder.ConditionNodeChild {
        [LocalExpatGuestCondition]: boolean;
    }

    export function isLocalExpatGuestCondition(condition?: QueryBuilder.ConditionNodeChild): condition is LocalExpatGuestCondition {
        if (!condition) {
            return false;
        }

        return (condition as LocalExpatGuestCondition)[LocalExpatGuestCondition] === true;
    }

    export function createLocalExpatGuestCondition(skipHydration: boolean = false): LocalExpatGuestCondition {

        const condition: LocalExpatGuestCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [LocalExpatGuestCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            dispose: () => { }
        };

        return condition;
    }

    function serializeLocalExpatGuestCondition(condition: LocalExpatGuestCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const alwaysDto: LocalExpatGuestConditionDto = {
            NodeId: condition.id
        };

        return {
            Type: "LocalExpatGuest",
            Value: alwaysDto
        };
    }

    interface LocalExpatGuestConditionDto extends QueryBuilder.NodeDto {
        //
    }

    function deserializeLocalExpatGuestCondition(always: LocalExpatGuestConditionDto): LocalExpatGuestCondition {
        const condition = createLocalExpatGuestCondition(true);
        return condition;
    }
}